import { getUserAuthRedux } from "../helpers/functions/auth";

export class ModelMultipleLocationAccount {
  constructor(props = {}) {
    const userAuth = getUserAuthRedux()

    this.id = props.id;
    this.sfid = props.sfid;
    this.name = props.name;
    this.isSelected = this.sfid === userAuth.adRefId;
  }
}